import React, { useContext } from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function ShownIn() {
  const ProductPageState = useContext(ProductPageContext);

  const {
    tmntData,
    collectionData,
  } = ProductPageState;

  if (!collectionData || !collectionData.activeProduct) {
    return null;
  }

  const { activeProduct } = collectionData;

  return (
    <h3 className="shown_in__h3-mfe" data-testid="shown-in-component" data-text-key={tmntData?.shownInText.key}>
      {activeProduct?.swatchLabel === 'color' ? tmntData?.colorText.value : tmntData?.shownInText.value}
      :
      {' '}
      <span className="h3__span">{activeProduct.swatchName}</span>
    </h3>
  );
}
